import React, { useState, useEffect } from 'react';
import { Play, Square } from 'lucide-react';
import strings from '../../data/frontendSimulation.json';
import './style.css';

const useT = (lang = 'en') => (path, fallback = '') =>
  path.split('.').reduce((acc, k) => (acc && acc[k] !== undefined ? acc[k] : undefined), strings[lang]) ?? fallback;

const FrontendSimulation = ({ lang = 'en' }) => {
  const t = useT(lang);

    const files = [
    { name: '📁 src/', active: false },
    { name: '⚛️ App.js', active: false },
    { name: '🎨 styles.css', active: false },
    { name: '📄 index.html', active: false }
  ];

  const tasks = t('tasks', []);
  const filesConfig = t('files', []);

  const [progress, setProgress] = useState(0);
  const [currentTask, setCurrentTask] = useState('');
  const [isRunning, setIsRunning] = useState(false);
  const [currentFileIndex, setCurrentFileIndex] = useState(0);

  // Безопасные шаги вместо «магии» 16.67 и 25
  const TASK_STEP = tasks.length > 0 ? 100 / tasks.length : 100;
  const FILE_STEP = filesConfig.length > 0 ? 100 / filesConfig.length : 100;

  useEffect(() => {
    if (!isRunning) return;

    const interval = setInterval(() => {
      setProgress((prev) => {
        const next = prev >= 100 ? 0 : Math.min(100, prev + TASK_STEP);
        const taskIndex = Math.min(tasks.length - 1, Math.floor(next / TASK_STEP));
        setCurrentTask(tasks[taskIndex] || tasks[tasks.length - 1] || '');

        // Обновляем «активный» файл
        const fileIdx = Math.min(files.length - 1, Math.floor(next / FILE_STEP));
        setCurrentFileIndex(fileIdx);

        // Автостоп на 100%
        if (next >= 100) {
          setIsRunning(false);
        }
        return next;
      });
    }, 800);

    return () => clearInterval(interval);
  }, [isRunning, TASK_STEP, FILE_STEP, tasks, files.length]);

  const toggleSimulation = () => {
    // Если цикл завершён — «перезапуск»
    if (!isRunning && progress >= 100) {
      setProgress(0);
      setCurrentTask('');
      setCurrentFileIndex(0);
    }
    setIsRunning((s) => !s);
  };

  const buttonLabel = isRunning
    ? t('buttons.stop')
    : progress >= 100
    ? t('buttons.restart')
    : t('buttons.start');

  return (
    <div className="frontend-simulation">
      <div className="simulation-controls">
        <button className="simulation-btn" onClick={toggleSimulation}>
          {isRunning ? <Square size={16} /> : <Play size={16} />}
          {buttonLabel}
        </button>
      </div>

      <div className="terminal">
        <div className="terminal-header">
          <div className="terminal-controls">
            <span className="control red"></span>
            <span className="control yellow"></span>
            <span className="control green"></span>
          </div>
          <span className="terminal-title">{t('terminal.title')}</span>
        </div>
        <div className="terminal-body">
          <div className="terminal-line">{t('terminal.cmd')}</div>
          <div className="terminal-line">
            <span className="prompt"></span> {currentTask}
            {isRunning && <span className="cursor">|</span>}
          </div>
        </div>
      </div>

      <div className="progress-container">
        <div className="progress-label">
          {t('labels.progress')}: {Math.round(progress)}%
        </div>
        <div className="progress-bar">
          <div className="progress-fill" style={{ width: `${progress}%` }} />
        </div>
      </div>

      <div className="file-structure">
        <div className="file-header">{t('labels.projectStructure')}</div>
        {files.map((file, index) => (
          <div key={index} className={`file ${index <= currentFileIndex ? 'active' : ''}`}>
            {file.name}
            {index <= currentFileIndex && <span className="file-status">✓</span>}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FrontendSimulation;